import { render, staticRenderFns } from "./RoleEdit.vue?vue&type=template&id=87e1df5e&"
import script from "./RoleEdit.vue?vue&type=script&lang=ts&"
export * from "./RoleEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports